import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=411ebdac&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=411ebdac&prod&scoped=true&lang=css"
import style1 from "./CustomerDetail.vue?vue&type=style&index=1&id=411ebdac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411ebdac",
  null
  
)

export default component.exports